import { FormControl, FormErrorMessage, Radio, RadioGroup, Spinner, Stack } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos/Travel'
import { SelectionType } from 'brokertslib/src/enums'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel } from '../../components/FormLabel'
import { RadioStack } from '../../components/RadioStack'
import { useSelections } from '../../hooks'

export const TripKind = ({ isContracted }: { isContracted: boolean }) => {
  const { control, formState: { errors } } = useFormContext<InsuranceParamsTravelDto>()

  const { data: dataTravelType, isLoading: isLoadingTravelType, isFetching: isFetchingTravelType } = useSelections(SelectionType.TravelType)

  return (
    <FormControl isRequired isInvalid={!!errors.travel?.travelType}>
      <Stack direction={'row'}>
        <FormLabel>Druh cesty</FormLabel>
        {(isFetchingTravelType || isLoadingTravelType) && <Spinner />}
      </Stack>
      <Controller
        name="travel.travelType"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
            <RadioStack variant="stackedTile">
              {dataTravelType?.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  {item.description}
                </Radio>
              ))}
            </RadioStack>
          </RadioGroup>
        )}
      />
      {errors.travel?.travelType && <FormErrorMessage>{errors.travel.travelType.message}</FormErrorMessage>}
    </FormControl>
  )
}
